export const ex40ModelData = {
  model: "EX40",
  points: [
    {
      categoryNodeId: "1e7b1af1fb6d8d6ac0a801887633d99d",
      title: "Vehicle propulsion",
      x: 250,
      y: 150,
      hoverImg: "EX40_Vehicle_propulsion_v01.webm",
      type: "video",
    },
    {
      categoryNodeId: "5efd493dfb73376fc0a80188726385fb",
      title: "Power transmission",
      x: 200,
      y: 200,
      hoverImg: "EX40_Power_transmission_v01.webm",
      type: "video",
    },
    {
      categoryNodeId: "47e3e396fb72a5cdc0a801885b2cf00b",
      title: "Electrical systems",
      x: 520,
      y: 150,
      hoverImg: "EX40_Electrical_system_v01.webm",
      type: "video",
    },
    {
      categoryNodeId: "f6ae00ed83afa358c0a801883e117eaf",
      title: "Infotainment, connectivity and multimedia",
      x: 420,
      y: 120,
      hoverImg: "EX40_Infotainment.png",
      type: "image",
    },
    {
      categoryNodeId: "ded8d616fb74d60cc0a801883c445a96",
      title: "Brake system",
      x: 470,
      y: 300,
      hoverImg: "EX40_Brake_system.png",
      type: "image",
    },
    {
      categoryNodeId: "4605020f2fc33b33c0a8018816aa24c6",
      title: "Safety systems",
      x: 680,
      y: 30,
      hoverImg: "EX40_Safety_system.png",
      type: "image",
    },
    {
      categoryNodeId: "c46608fbfb75842ec0a8018849dfc62c",
      title: "Wheel suspension",
      x: 480,
      y: 200,
      hoverImg: "EX40_Wheel_suspension.png",
      type: "image",
    },
    {
      categoryNodeId: "78aa1fadfb75336ec0a8018812651161",
      title: "Steering",
      x: 310,
      y: 280,
      hoverImg: "EX40_Steering.png",
      type: "image",
    },
    {
      categoryNodeId: "6d69509e71b56d56c0a80188269b3ee5",
      title: "Wheels and rims",
      x: 740,
      y: 200,
      hoverImg: "EX40_Wheel and rims.png",
      type: "image",
    },
    {
      categoryNodeId: "4bfe8172fb77a4cdc0a801881c69b634",
      title: "Body",
      x: 700,
      y: 240,
      hoverImg: "EX40_Body.png",
      type: "image",
    },
    {
      categoryNodeId: "c15c6701fb7802fbc0a801882587f21e",
      title: "Exterior",
      x: 680,
      y: 120,
      hoverImg: "EX40_Exterior.png",
      type: "image",
    },
    {
      categoryNodeId: "5b7d41c7fb76fddfc0a8018848ebaad4",
      title: "Interior",
      x: 620,
      y: 70,
      hoverImg: "EX40_Interior.png",
      type: "image",
    },
  ],
};